<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="wrapper">
				<div class="container">
					<div class="body">
						<div class="body__title">
							<h1 class="body__title-text">Resetar Senha</h1>
						</div>
						<div class="body__description">
							<p class="body__description-text">
								Para resetar a senha deste usuário, você precisa escolher entre as opções:
							</p>
						</div>
					</div>
					<div class="actions">
						<button
							id="action-btn"
							class="actions__btn"
							:class="isLoadingUsers ? 'disabled' : ''"
							@click="sendEmail()"
						>
							<span v-if="!isLoadingUsers">Enviar E-mail para Recuperação de Senha</span>
							<SpinnerIcon :color="'white'" v-else />
						</button>
					</div>
					<div class="actions">
						<button
							id="action-btn"
							class="actions__btn"
							:class="isLoadingUsers ? 'disabled' : ''"
							@click="handleNewPasswordModal()"
						>
							<span v-if="!isLoadingUsers">Modificar Senha do Usuário pelo Admin </span>
							<SpinnerIcon :color="'white'" v-else />
						</button>
					</div>
					<div class="actions">
						<button
							id="action-btn"
							class="actions__btn outline"
							@click="handleResetPasswordModal()"
						>
							Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';
import CloseIcon from '@/components/shared/Icons/CloseIcon.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';

export default {
	name: 'ResetPasswordModal',
	components: { CloseIcon, SpinnerIcon },
	data: () => ({
		showNewPasswordModal: false,
	}),
	mounted() {},
	methods: {
		handleResetPasswordModal() {
			this.$emit('handleResetPasswordModal');
		},
		handleNewPasswordModal() {
			this.handleResetPasswordModal();
			this.$emit('handleNewPasswordModal');
		},
		sendEmail() {
			this.$emit('sendEmail');
		},
	},
	computed: {
		...mapGetters('userManagement', ['isLoadingUsers']),
	},
};
</script>

<style lang="scss" scoped>
@import 'ResetPasswordModal.scss';
</style>
